if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
      }
      
      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }
      
      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }
      
      connectedCallback() {
        this.initVariantElements();

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          
          if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          }
        });
      }
      
      initVariantElements() {
        if (this.initialized) return;
        
        const optionContainers = this.querySelectorAll('.product_variant_option_inner');
        optionContainers.forEach(container => {
          container.classList.add('loaded');
          container.style.height = 'auto';
          
          const input = container.querySelector('input[type="radio"]');
          if (input && input.name.includes('\n')) {
            input.name = input.name.replace(/\n/g, '');
          }
        });
        
        this.initSelectedValues();
        
        this.initialized = true;
        
        setTimeout(() => {
          this.updateAllVariantContainers();
        }, 100);
      }
      
      updateAllVariantContainers() {
        const optionContainers = this.querySelectorAll('.product_variant_option_inner');
        optionContainers.forEach(container => {
          container.classList.add('loaded');
          container.style.height = 'auto';
        });
      }
      
      initSelectedValues() {
        const fieldsets = this.querySelectorAll('fieldset');
        fieldsets.forEach((fieldset, index) => {
          const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
          if (selectedInput) {
            const optionNameElement = fieldset.querySelector('.font-body-bold');
            if (optionNameElement) {
              const optionName = optionNameElement.textContent.replace(':', '').trim();
              const valueDisplay = fieldset.querySelector(`[data-selected-swatch-value="${optionName}"]`);
              
              if (valueDisplay) {
                valueDisplay.textContent = selectedInput.value;
              }
            }
          }
        });
      }
      
      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;
        
        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');
          
          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          
          if (!selectedDropdownSwatchValue) return;
          
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }
          
          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
          
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const fieldset = target.closest('fieldset');
          if (!fieldset) return;
          
          const optionNameElement = fieldset.querySelector('.font-body-bold');
          if (optionNameElement) {
            const optionName = optionNameElement.textContent.replace(':', '').trim();
            const selectedSwatchValue = fieldset.querySelector(`[data-selected-swatch-value="${optionName}"]`);
            
            if (selectedSwatchValue) {
              selectedSwatchValue.textContent = value;
            }
          }
          
          const allOptions = fieldset.querySelectorAll('.product_variant_option_inner');
          allOptions.forEach(option => {
            const optionInput = option.querySelector('input[type="radio"]');
            if (optionInput && optionInput === target) {
              option.classList.add('selected');
            } else {
              option.classList.remove('selected');
            }
          });
        }
      }
    }
  );
}

function fixVariantSelectors() {
  const variantSelects = document.querySelectorAll('variant-selects');
  
  variantSelects.forEach(selector => {
    if (typeof selector.initVariantElements === 'function') {
      selector.initVariantElements();
    }
    
    const optionContainers = selector.querySelectorAll('.product_variant_option_inner');
    optionContainers.forEach(container => {
      container.classList.add('loaded');
      container.style.height = 'auto';
    });
  });
}

document.addEventListener('DOMContentLoaded', fixVariantSelectors);
document.addEventListener('shopify:section:load', fixVariantSelectors);

const observer = new MutationObserver(function(mutations) {
  let shouldFix = false;
  
  for (const mutation of mutations) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'VARIANT-SELECTS' || node.querySelector('variant-selects')) {
            shouldFix = true;
            break;
          }
        }
      }
    }
    if (shouldFix) break;
  }
  
  if (shouldFix) {
    setTimeout(fixVariantSelectors, 50);
  }
});

if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
}